import { Card, Col, List, Row } from "antd";
import React from "react";
import { FcDataSheet } from "react-icons/fc";
import { useSelector } from "react-redux";
import StrategicPlanCards from "./StrategicPlanCards";

const StrategicPlanDashboard = () => {
  const { dashboardData: data } = useSelector((state) => state.dashboardState);

  return (
    <Row gutter={4}>
      <Col md={12} sm={24} lg={12} xs={24}>
        <Card title="STRATEGIC PLAN DASHBOARD SUMMARY">
          <List
            pagination={{ position: "bottom", align: "center", pageSize: 5 }}
            dataSource={data?.strategicPlanData?.targetUnitData || []}
            renderItem={(item, index) => (
              <List.Item key={index}>
                <List.Item.Meta
                  avatar={<FcDataSheet />}
                  title={item.targetUnit}
                  description={`Target: ${item.totalTarget?.toLocaleString()} | Achieved: ${item.totalAchieved?.toLocaleString()} | Variance: ${item.variance?.toLocaleString()}`}
                />
              </List.Item>
            )}
          />
        </Card>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <StrategicPlanCards />
      </Col>
    </Row>
  );
};

export default StrategicPlanDashboard;
